// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unordered-parts[data-v-a15d21b6] {\n  display: grid;\n  grid-template-columns: 2% 5% 30% 3% 10% 5% 3% 15% 9% 9% 9%;\n}\n.unordered-parts.is-editable[data-v-a15d21b6]:hover {\n  border: gray 1px solid;\n  cursor: text;\n}", ""]);
// Exports
module.exports = exports;
